export default __webpack_public_path__ + "static/media/bg_user.7b849504.png";